export function PostData(type, userData){
    let BaseUrl = 'https://api.pattys-cakes.com/';
    return new Promise((res, rej) =>{

        fetch(BaseUrl+type+"/", {
            method:"POST",
            body:JSON.stringify(userData)
        })
        .then((res) => {
            if (res.status !== 200) {
                throw "Failed to log in";
               } else {
                return res.json()
            }
        })  
        .then((resJson) =>{
            res(resJson);
        })
        .catch(error =>{
            rej(error);
        })
    })
}


// WEBPACK FOOTER //
// ./src/services/PostData.js